import { NuqsAdapter } from 'nuqs/adapters/next/pages'
import React from 'react'

import { LookListBlockV2 } from '@Blocks/LookList/v2'
import { Looks } from '@Components/Looks'
import { useTileSettings } from '@Components/Tiles/settings'
import {
  LookListBlock as LookListBlockGraphQL,
  ProductListBlockFragmentFragment,
} from '@Generated/graphql'
import { LookSearchProvider } from '@Globals/Algolia/Looks/Context'
import { processURLSearchParams } from '@Globals/Algolia/Shared'
import { BlockContext, useBlockConfig } from '@Globals/CMS/Context'
import { Trans } from '@Globals/Translations'

const LookListBlockStatic = ({
  data,
  id,
}: {
  data: LookListBlockGraphQL
  id?: string
}) => {
  const { presentation } = React.use(BlockContext)
  const { appearance, common, looks, settings } = data
  const tileSettings = useTileSettings(settings)

  if (!looks || looks.length === 0) {
    return null
  }

  let titleOverride: React.ReactNode | undefined
  if (tileSettings.type === 'ambassador' && common?.title) {
    titleOverride = (
      <Trans
        components={{
          /* eslint-disable react/jsx-no-useless-fragment */
          Link: (
            <>
              <></>
              <>{common.title}</>
            </>
          ),
          /* eslint-enable react/jsx-no-useless-fragment */
        }}
        i18nKey="cms:MORE_LOOKS_FROM"
      />
    )
  }

  return (
    <Looks
      appearance={appearance}
      common={common}
      id={id}
      looks={looks}
      noPadding={looks.length === 1 && (tileSettings.version !== '2' || tileSettings.singleLook)}
      presentation={presentation}
      settings={settings}
      titleOverride={titleOverride}
    />
  )
}

const LookListBlock = ({
  data,
  id,
}: {
  data: LookListBlockGraphQL
  id?: string
}) => {
  const config = useBlockConfig()

  if (config.algolia?.usePagination) {
    return (
      <NuqsAdapter processUrlSearchParams={processURLSearchParams}>
        <LookSearchProvider
          facetConfig={(data.facetConfig || []) as ProductListBlockFragmentFragment['facetConfig']}
        >
          <LookListBlockV2 data={data} id={id} />
        </LookSearchProvider>
      </NuqsAdapter>
    )
  }

  return <LookListBlockStatic data={data} id={id} />
}

export default LookListBlock
